<template>
  <notification-box v-if="!isVerified" class="container" type="error">
    <div class="info" slot="info">
      <span v-html="$t('verify.email.warning.box', { email })"></span>
    </div>
    <a-button class="button" type="primary" slot="actions" @click="sendVerificationEmail">
      {{
      $t('verify.email.again.button')
      }}
    </a-button>
  </notification-box>
</template>

<script>
import firebase from 'firebase/app';
import { mapActions } from 'vuex';
import NotificationBox from '@/components/account/NotificationBox.vue';
import { SEND_VERIFICATION_EMAIL } from '@/store/session/actionTypes';

export default {
  components: {
    NotificationBox,
  },
  computed: {
    user() {
      return firebase.auth().currentUser;
    },
    isVerified() {
      return this.user?.emailVerified;
    },
    email() {
      return this.user?.email;
    },
  },
  methods: {
    ...mapActions({
      sendVerificationEmail: SEND_VERIFICATION_EMAIL,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.container {
  padding: 6px 15px;
  margin-bottom: 20px;
}

.ant-btn {
  margin: 0;
}

@media (max-width: $page-table-breakpoint) {
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .info {
    text-align: center;
  }

  .button {
    margin-top: 10px;
    max-width: $page-mobile-small-breakpoint;
    width: 100%;
  }
}
</style>
